import { Link } from "react-router-dom";

const StripeConnectFailed = () => {


    return (
        <div className="pt-5 pb-4">
            <div
                className="subscription-success-container"
                style={{ minHeight: "60vh", flexDirection: "column" }}
            >
                <div className="success-box">
                    <h2 className="success-title">Your session expired or was interrupted. Please click below to try again.</h2>
                    <p className="success-message">
                        Thank you for booking a nanny with us! Your reservation has been
                        confirmed, and your nanny will be there as scheduled to provide
                        quality care. We appreciate your trust in our service!
                    </p>

                    <div className="success-actions">
                        <Link to="/profilenanny" className="btna btn-primarya">
                            Try Again
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StripeConnectFailed;
